import { render, staticRenderFns } from "./PrestationsPage.vue?vue&type=template&id=2c983810&"
import script from "./PrestationsPage.vue?vue&type=script&lang=js&"
export * from "./PrestationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports